import React from "react";

import {
  Accordion,
  Typography,
} from "components/Common/clearsense-ui/components";

import { RESOURCE_PARAMETERS } from "./constants";

const Examples = ({ examples }) => {
  const isString = value =>
    typeof value === "string" || value instanceof String;

  const check = (value, parameterValues) => {
    if (!parameterValues.includes(value)) {
      parameterValues.push(value);
      return value;
    }

    return null;
  };

  const display = (value, keysToAvoid = [], parameterValues) => {
    if (isString(value)) {
      return check(value, parameterValues);
    }

    return Object.entries(value).map(
      ([key, value]) =>
        !keysToAvoid.includes(key) && (
          <div>
            {isString(value)
              ? check(value, parameterValues)
              : process(value, keysToAvoid, parameterValues)}
          </div>
        )
    );
  };

  const process = (value, keysToAvoid, parameterValues) => {
    if (Array.isArray(value, keysToAvoid)) {
      return value.map(element =>
        display(element, keysToAvoid, parameterValues)
      );
    }

    return display(value, keysToAvoid, parameterValues);
  };

  return (
    <Accordion>
      {examples.map(({ example }) => (
        <Accordion.Item
          title={example.meta.extension[0].valueString}
          key={example.id}
        >
          <div className="space-y-2">
            {RESOURCE_PARAMETERS.map(
              parameter =>
                example[`${parameter.value}`] && (
                  <div className="flex space-x-2" key={parameter.value}>
                    <Typography
                      style="medium"
                      className="text-indigo-700 dark:text-primary-lighter"
                    >
                      {parameter.label}:
                    </Typography>
                    <Typography
                      style="medium"
                      className="text-black dark:text-shade-light"
                    >
                      {process(
                        example[`${parameter.value}`],
                        parameter.keysToAvoid,
                        []
                      )}
                    </Typography>
                  </div>
                )
            )}
          </div>
        </Accordion.Item>
      ))}
    </Accordion>
  );
};

export default Examples;
